import { connect } from 'react-redux';

import { OfferCardImageBanner } from './offer-card-image-banner';
import { IState } from '../../../../store';
import { ITrackingReducerState } from '../../../../store/tracking';

export interface IOfferCardImageBannerStateProps {
  tracking: ITrackingReducerState;
  isInGage: boolean;
}

export const mapStateToProps = (state: IState): IOfferCardImageBannerStateProps => {
  return {
    tracking: state.tracking,
    isInGage: !!state.offerData.agent?.bank,
  };
};

export const OfferCardImageBannerContainer =
  connect<IOfferCardImageBannerStateProps>(mapStateToProps)(OfferCardImageBanner);
